import Vue from 'vue'

Vue.config.ignoredElements = [
  ...(Vue.config.ignoredElements || []),
  'iconify-icon',
]